(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-purchase-assurance"] && !Shopify.designMode) return;
  try {
    class ProductPurchaseAssurance extends HTMLElement {
    connectedCallback() {
      this.section = this.closest('.shopify-section, dialog');
      this.section?.addEventListener('variant:update', this.handleVariantUpdate);
      this.emiDialog = this.querySelector('[data-emi-dialog]');
      this.emiDialogTrigger = this.querySelector('[data-emi-dialog-open]');
      this.emiDialogTrigger?.addEventListener('click', this.openEmiDialog);
      this.emiDialog?.addEventListener('click', this.handleEmiDialogBackdrop);
    }

    disconnectedCallback() {
      this.section?.removeEventListener('variant:update', this.handleVariantUpdate);
      this.emiDialogTrigger?.removeEventListener('click', this.openEmiDialog);
      this.emiDialog?.removeEventListener('click', this.handleEmiDialogBackdrop);
    }

    openEmiDialog = () => this.emiDialog?.showModal();

    handleEmiDialogBackdrop = (event) => {
      if (event.target === this.emiDialog) this.emiDialog.close();
    };

    handleVariantUpdate = (event) => {
      if (String(event.detail?.data?.productId) !== this.dataset.productId) return;

      const available = Boolean(event.detail?.resource?.available);
      const label = available ? this.dataset.availableLabel : this.dataset.unavailableLabel;
      const status = this.querySelector('[data-assurance-availability]');

      this.dataset.variantAvailable = String(available);
      if (status && label) status.textContent = label;
    };
  }

  if (!customElements.get('product-purchase-assurance')) {
    customElements.define('product-purchase-assurance', ProductPurchaseAssurance);
  }
  } catch(e) { console.error(e); }
})();

})();
